<script>
import { mapGetters } from "vuex";

export default {
  name: "Bahn1ImpulseNew",
  computed: {
    ...mapGetters("bahn1", ["impulseNew"]),
    items() {
      const list =
        this.impulseNew && Array.isArray(this.impulseNew.Impuls)
          ? this.impulseNew.Impuls
          : [];
      return list.filter(
        item => item && (item.Text || item.Label1 || item.Label2 || item.Bild)
      );
    }
  },
  methods: {
    imageUrl(item) {
      return this.$store.getters.getStrapiImageUrl(item.Bild);
    }
  }
};
</script>

<template>
  <div class="impulses" v-if="items.length">
    <h2 class="impulses-heading">Impulse aus der NEW</h2>
    <p class="impulses-text" v-if="impulseNew.ImpulseNEWText">
      {{ impulseNew.ImpulseNEWText }}
    </p>

    <div class="impulses-grid">
      <div class="impulse-card" v-for="(item, index) in items" :key="index">
        <img class="impulse-image" :src="imageUrl(item)" :alt="item.Label1" />
        <div class="impulse-content">
          <div class="impulse-labels">
            <span class="impulse-label" v-if="item.Label1">{{
              item.Label1
            }}</span>
            <span class="impulse-label" v-if="item.Label2">{{
              item.Label2
            }}</span>
          </div>
          <p class="impulse-text">{{ item.Text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.impulses-heading {
  margin-top: 56px;
  margin-bottom: 16px;
  font-size: 30px;
  letter-spacing: 0.6px;
}
.impulses-text {
  margin-bottom: 24px;
  letter-spacing: 0.32px;
  font-family: "GeometriaLight";
}
.impulses-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.impulse-card {
  width: 100%;
  max-width: 296px;
  background: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.impulse-image {
  display: block;
  width: 100%;
  height: 222px;
  object-fit: cover;
}
.impulse-content {
  padding: 16px;
}
.impulse-labels {
  display: flex;
  gap: 8px;
}
.impulse-label {
  background: #e4e4e4;
  color: #1f2b37;
  font-size: 12px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 4px;
}
.impulse-text {
  margin: 12px 0 0;
  font-family: "GeometriaMedium", sans-serif;
  font-size: 16px;
  letter-spacing: 0.32px;
  color: #b40055;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}
</style>
